import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { Box, Text, ModalControl } from '@paygreen/paygreen-ui';
import IconByName from '../../utils/IconByName';
import { addProductModes } from '../../utils/constants';
import { ModalControlClose } from '../../components';

const ActionLink = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    padding: ${(props) => props.theme.space.sm};
    transition: all ${(props) => props.theme.transition.xs};

    &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: ${(props) => props.theme.zindex.layer};
        width: 100%;
        height: 100%;
        opacity: 0;
        background-color: ${(props) => props.theme.wab.grey20};
        transition: all ${(props) => props.theme.transition.xs};
    }

    &:hover,
    &:active,
    &:focus {
        &::after {
            height: 100%;
            opacity: 0.4;
        }
    }
`;

const AddProductPopin = ({
    t,
    setOpen: setDropdownOpen,
    setAddProductMode,
}) => {
    const popinAction = (mode) => {
        setAddProductMode(mode);
        setDropdownOpen(false);
    };

    const addOptions = [
        {
            title: t('matching.popin.manuallyMode'),
            icon: 'PointerIcon',
            mode: addProductModes.manual,
        },
        {
            title: t('matching.popin.csvMode'),
            icon: 'DownloadIcon',
            mode: addProductModes.csv,
        },
        // waiting for API CMS mode to be ready
        // {
        //     title: t('matching.popin.cmsMode'),
        //     icon: 'ShopIcon',
        //     mode: addProductModes.cms,
        // },
    ];

    return (
        <Box paddingTop="sm" paddingBottom="sm">
            {addOptions.map((option) => (
                <ModalControl key={option.title}>
                    <ModalControlClose action={() => popinAction(option.mode)}>
                        <ActionLink>
                            <IconByName
                                name={option.icon}
                                iconSize="md"
                                colorPallet="wab"
                                colorWab="grey40"
                                marginRight="sm"
                                marginLeft="sm"
                            />

                            <Text
                                colorWab="grey40"
                                htmlTag="strong"
                                textSize="xs"
                                marginRight="lg"
                            >
                                {option.title}
                            </Text>
                        </ActionLink>
                    </ModalControlClose>
                </ModalControl>
            ))}
        </Box>
    );
};

AddProductPopin.propTypes = {
    /**
     * hook received from DropdownControl component to close popin
     */
    setOpen: PropTypes.func.isRequired,
};

export default withTranslation('common')(AddProductPopin);
